export type AudioError = {
  code:
    | "PERMISSION_DENIED"
    | "INITIALIZATION_ERROR"
    | "RECORDING_ERROR"
    | string;
  message: string;
  originalError?: unknown;
};

export interface AudioInputSource {
  getStream(): Promise<MediaStream>;
  stopStream(): void;
}

export class DefaultAudioInput implements AudioInputSource {
  private currentStream: MediaStream | null = null;

  constructor(private constraints: MediaStreamConstraints = { audio: true }) {
    console.info("🎙️ DefaultAudioInput: Initializing browser audio source");
  }

  async getStream(): Promise<MediaStream> {
    console.info("🎙️ DefaultAudioInput: Getting audio stream");
    try {
      this.currentStream = await navigator.mediaDevices.getUserMedia(
        this.constraints,
      );
      console.info("🎙️ DefaultAudioInput: Successfully obtained MediaStream");
      return this.currentStream;
    } catch (error) {
      console.error("🎙️ DefaultAudioInput: Failed to get stream:", error);
      throw error;
    }
  }

  stopStream(): void {
    console.info("🎙️ DefaultAudioInput: Stopping stream");
    if (this.currentStream) {
      console.info("🎙️ DefaultAudioInput: Stopping MediaStream tracks");
      this.currentStream.getTracks().forEach((track) => {
        track.stop();
        console.debug(
          "🎙️ DefaultAudioInput: Stopped track:",
          track.kind,
          track.label,
        );
      });
      this.currentStream = null;
    }
  }
}
